import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
// import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
// import Divider from '@material-ui/core/Divider';
// import Icon from '@material-ui/core/Icon';
import { Link } from "routes";
// import styled from 'styled-components';
import {getMobileNewsItemVideoThumbnail, getDesktopNewsItemVideoThumbnail, extractYoutubeVideoID} from '/utils/common'
// import SponsorChip from '/components/sponsorChip';
import CustomImage from '/components/customImage';
import classNames from 'classnames';
// import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
// import BrandTeaserLogo from '/components/brandTeaserLogo';
// import NewsItemParts from '/components/newsItemParts';
import { compose } from 'recompose';
import PlayIconButton from '/components/playIconButton';

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: '0px 0px  14px',
  },
  textContainer: {
    padding: '0px 0px 0px 14px'
  },
  img: {
    background: 'rgba(128, 128, 128, 0.11)',
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    width: '100%',
    objectFit: 'cover',
   
  },
  mobileImg:{
    height: 100
  },
  customDivider: {
    margin: '14px 0px 0px'
  },
  playerIconStyle: {
    color: '#ed7123',
    position: 'absolute',
    bottom: 2,
    left: 2,
    fontSize: 25
  },
  playerIconWrapperStyle: {
    width: 32,
    height: 32, 
    background: '#fff',
    position: 'absolute',
    borderRadius: '50%',
    bottom: 5,
    left: 4,
    border: '2px solid #ed7123'
  },

});

class NewsItemImgOrPoster extends React.Component {
  render(){
  const { item, classes, className, imgHeight } = this.props;
  const suggestedPostClass = this.props.className ? this.props.className : 'article';
  const isHostedVideoItem = item.media_id && item.posters;
  const videoUrlThumbnail = isHostedVideoItem ? item.posters.video_section_teaser : 
    (item.video_url ?  (this.props.width === 'xs' ? 
    getMobileNewsItemVideoThumbnail(extractYoutubeVideoID(item.video_url)) : 
    getDesktopNewsItemVideoThumbnail(extractYoutubeVideoID(item.video_url))) : '');
  const videoThumbnail = item.video ? item.video.posters.thumb : '' 
  return (
    item.type === 'VIDEO' || item.type === 'VIDEO_URL' || item.video || item.video_url ?
        <div style={{position: 'relative'}}>
          <Link route={`${item.path}`}> 
              <a className="anchor-link">
                  <CustomImage // for video article
                    imgSrc={item.type === 'VIDEO' ? videoThumbnail : videoUrlThumbnail}
                    imgClass={classNames(classes.img, suggestedPostClass)} 
                    customStyle={`cursor: pointer; height: ${imgHeight};`} 
                  />  
              </a>
          </Link>
          <Link route={`${item.path}`}>
              <a className="anchor-link">
                  <PlayIconButton />
              </a>
          </Link>
        </div> 
        :
        item.type === 'GRAPHIC' || item.graphic && item.graphic.thumb ?
          <Link route={`${item.path}`}>
            <a className="anchor-link">
            <picture>
              {/* {
              item.graphic.thumb_webp &&
              <source srcSet={item.graphic.thumb_webp} type="image/webp" />
              } */}
                <CustomImage // for graphic article
                  imgSrc={item.graphic.thumb}
                  imgClass={classNames(classes.img, className)} 
                  customStyle={`cursor: pointer; height: ${imgHeight}; objectFit: contain`} 
                />
            </picture>
            </a>
          </Link>
        :
        <Link route={`${item.path}`}>
          <a className="anchor-link">
              {this.props.width === 'xs' ?
                  <span style={{ overflowY: 'auto', height: 400 }}>
                      <CustomImage // for article (mobile view)
                        imgSrc={item.cover.thumb_mobile} 
                        imgClass={classes.img} 
                        className={classNames(classes.mobileImg, suggestedPostClass)} 
                      />
                  </span>
                  :
                  <picture>
                  {/* {
                  item.cover.thumb_webp &&
                  <source srcSet={item.cover.thumb_webp} type="image/webp" />
                  } */}
                  <CustomImage 
                    imgSrc={item.cover.thumb}  // for article (desktop view)
                    imgClass={classNames(classes.img, className)} 
                    customStyle={`cursor: pointer; height: ${imgHeight}`} 
                  />
                  </picture>                                    
              }
              </a>
          </Link>
        );
    }
}

NewsItemImgOrPoster.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(
    withWidth(),
    withStyles(styles))(NewsItemImgOrPoster);
